import _ from 'lodash';
import {
  PRODUCT_ALL,
  PRODUCT_GET,
  PRODUCT_DEL,
  PRODUCT_PUT,
  PRODUCT_POST,
  PRODUCT_LOADING,
  PRODUCT_ERROR,
  PRODUCT_EXPORT_EXCEL,
} from '../types';

import api from '../../../utils/functions/api';

export const productCreate = (payload) => async (dispatch) => {
  console.log('Payload in Action', payload);
  try {
    dispatch({ type: PRODUCT_LOADING });

    const { data } = await api.post(
      `${process.env.REACT_APP_API_URL}/product`,
      {
        ...payload,
      },
    );

    dispatch({ type: PRODUCT_POST, payload: data });
  } catch (error) {
    console.error(error);
    dispatch({ type: PRODUCT_ERROR });
    throw new Error(`ไม่สามารถสร้างสินค้าได้ ${error}`);
  }
};
export const productCreateWithCSV = (payload) => async (dispatch) => {
  console.log('Payload in Action 444', payload);
  try {
    dispatch({ type: PRODUCT_LOADING });

    const { data } = await api.post(
      `${process.env.REACT_APP_API_URL}/product/csv`,
      {
        ...payload,
      },
    );

    dispatch({ type: PRODUCT_POST, payload: data });
  } catch (error) {
    console.error(error);
    dispatch({ type: PRODUCT_ERROR });
    throw new Error(`ไม่สามารถสร้างสินค้าได้ ${error}`);
  }
};

export const productAll = (params) => async (dispatch) => {
  try {
    const {
      name = '',
      size = '',
      page = 1,
      selectStocks = '',
      startDate = '',
      endDate = '',
      selectProductType = '',
      selectBrand = '',
      DashBoardPage = false,
    } = params;
    const { data, status } = await api.get(
      `${process.env.REACT_APP_API_URL}/product?name=${name}&size=${size}&page=${page}&selectStocks=${selectStocks}&startDate=${startDate}&endDate=${endDate}&selectProductType=${selectProductType}&selectBrand=${selectBrand}&DashBoardPage=${DashBoardPage}`,
    );
    // console.log('Data..', data);
    if (status === 200) {
      dispatch({ type: PRODUCT_ALL, payload: data });
    }
  } catch (error) {
    console.error(error);
    dispatch({ type: PRODUCT_ERROR });
    // throw new Error(error);
  }
};

export const productAllWithLightWeight = (params) => async (dispatch) => {
  try {
    const {
      name = '',
      size = '',
      page = 1,
      startDate = '',
      endDate = '',
    } = params;
    const { data, status } = await api.get(
      `${process.env.REACT_APP_API_URL}/product/light-weight?name=${name}&size=${size}&page=${page}&startDate=${startDate}&endDate=${endDate}`,
    );
    // console.log('Data..', data);
    if (status === 200) {
      dispatch({ type: PRODUCT_ALL, payload: data });
    }
  } catch (error) {
    console.error(error);
    dispatch({ type: PRODUCT_ERROR });
    // throw new Error(error);
  }
};

export const productAllForDashboard = (params) => async (dispatch) => {
  try {
    const {
      name = '',
      size = '',
      page = 1,
      startDate = '',
      endDate = '',
    } = params;
    const { data, status } = await api.get(
      `${process.env.REACT_APP_API_URL}/product/dashboard?name=${name}&size=${size}&page=${page}&startDate=${startDate}&endDate=${endDate}`,
    );
    // console.log('Data..', data);
    if (status === 200) {
      dispatch({ type: PRODUCT_ALL, payload: data });
    }
  } catch (error) {
    console.error(error);
    dispatch({ type: PRODUCT_ERROR });
    // throw new Error(error);
  }
};

export const productGet = (id) => async (dispatch) => {
  try {
    const { data, status } = await api.get(
      `${process.env.REACT_APP_API_URL}/product/${id}`,
    );
    if (status === 200) {
      dispatch({ type: PRODUCT_GET, payload: data });
    }
  } catch (error) {
    console.error(error);
    dispatch({ type: PRODUCT_ERROR });
    throw new Error(error);
  }
};

export const productPut = (id, payload) => async (dispatch) => {
  try {
    dispatch({ type: PRODUCT_LOADING });
    const ArrayUploadData = [];

    if (payload?.file) {
      console.log('Payload in Action', payload?.file);
      // Upload File First
      // eslint-disable-next-line no-restricted-syntax
      for await (const file of payload?.file) {
        console.log('file in action', file);
        // eslint-disable-next-line no-underscore-dangle
        if (file?._id) {
          ArrayUploadData.push(file);
        } else {
          const formData = new FormData();
          formData.append('file', file);

          const { data: uploadData } = await api.post(
            `${process.env.REACT_APP_API_URL}/uploads/file`,
            formData,
            {
              headers: { 'Content-Type': 'multipart/form-data' },
            },
          );

          console.log('Upload Data', uploadData);
          ArrayUploadData.push(uploadData);
        }
      }

      console.log('ArrayUploadData', ArrayUploadData);

      const { data } = await api.put(
        `${process.env.REACT_APP_API_URL}/product/${id}`,
        {
          ...payload,
          // eslint-disable-next-line no-underscore-dangle
          files: _.map(ArrayUploadData, (e) => ({ file: e.id || e._id })),
        },
      );
      dispatch({ type: PRODUCT_PUT, payload: data });
    }
    if (payload?.video) {
      console.log('Payload in Action', payload?.video);
      // Upload File First
      // eslint-disable-next-line no-restricted-syntax
      for await (const file of payload?.video) {
        console.log('file in action', file);
        // eslint-disable-next-line no-underscore-dangle
        if (file?._id) {
          ArrayUploadData.push(file);
        } else {
          const formData = new FormData();
          formData.append('file', file);

          const { data: uploadData } = await api.post(
            `${process.env.REACT_APP_API_URL}/uploads/file`,
            formData,
            {
              headers: { 'Content-Type': 'multipart/form-data' },
            },
          );

          console.log('Upload Data', uploadData);
          ArrayUploadData.push(uploadData);
        }
      }

      console.log('ArrayUploadData', ArrayUploadData);

      const { data } = await api.put(
        `${process.env.REACT_APP_API_URL}/product/${id}`,
        {
          ...payload,
          // eslint-disable-next-line no-underscore-dangle
          videos: _.map(ArrayUploadData, (e) => ({ video: e?.id || e?._id })),
        },
      );
      dispatch({ type: PRODUCT_PUT, payload: data });
    } else {
      const { data } = await api.put(
        `${process.env.REACT_APP_API_URL}/product/${id}`,
        payload,
      );
      dispatch({ type: PRODUCT_PUT, payload: data });
    }
  } catch (error) {
    console.error(error);
    dispatch({ type: PRODUCT_ERROR });
    throw new Error(error);
  }
};
export const productDelete = (id) => async (dispatch) => {
  try {
    dispatch({ type: PRODUCT_LOADING });
    const { data } = await api.delete(
      `${process.env.REACT_APP_API_URL}/product/${id}`,
    );
    dispatch({ type: PRODUCT_DEL, payload: data });
  } catch (error) {
    console.error(error);
    dispatch({ type: PRODUCT_ERROR });
    throw new Error(error);
  }
};

export const productReset = () => async (dispatch) => {
  dispatch({ type: PRODUCT_LOADING });
};

export const productAllExcel = (params) => async (dispatch) => {
  try {
    dispatch({ type: PRODUCT_LOADING });
    const {
      name = '',
      size = '',
      page = 1,
      selectStocks = '',
      startDate = '',
      endDate = '',
      selectProductType = '',
      selectBrand = '',
      DashBoardPage = false,
    } = params;
    console.log('name', name);

    const response = await api.post(
      `${process.env.REACT_APP_API_URL}/product/export-all`,
      {
        name,
        size,
        page,
        selectStocks,
        startDate,
        endDate,
        selectProductType,
        selectBrand,
        DashBoardPage,
      },
      {
        responseType: 'blob',
        timeout: 180000
      }
    );

    // Create blob from response
    const blob = new Blob([response.data], {
      type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
    });

    // Create download link
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;

    // Generate filename with timestamp
    const timestamp = new Date().toISOString().split('T')[0];
    link.download = `รายงานข้อมูลสินค้า_${timestamp}.xlsx`;

    // Trigger download
    document.body.appendChild(link);
    link.click();

    // Cleanup
    window.URL.revokeObjectURL(url);
    document.body.removeChild(link);

    dispatch({ type: PRODUCT_EXPORT_EXCEL });

  } catch (error) {
    console.error('Export Excel Error:', error);
    dispatch({ type: PRODUCT_ERROR });
    throw new Error('ไม่สามารถดาวน์โหลดไฟล์ Excel ได้');
  }
};
